// Imports
import { Content, Container, ComponentWrapper, Img } from "@/components";

// Floating Image With Text
export function FloatingImageWithText({
  type,
  content,
  image,
  imageAlignment,
  backgroundColor,
}) {
  return (
    <ComponentWrapper type={type}>
      <div style={{ backgroundColor }} className="py-5 xl:py-0">
        <Container overflow width="lg">
          <div className="relative z-20 grid items-center justify-center w-full h-full my-10 space-y-4 xl:my-20 xl:grid-cols-2 lg:space-x-10 lg:flex-row lg:space-y-0">
            {imageAlignment.value === "right" && (
              <Content className="w-full p-5 xl:py-20" content={content} />
            )}
            <div className="flex justify-center w-full p-5 rounded-lg xl:scale-150">
              <Img className="h-full max-w-sm" data={image} />
            </div>
            {imageAlignment.value === "left" && (
              <Content className="w-full p-5 xl:py-20" content={content} />
            )}
          </div>
        </Container>
      </div>
    </ComponentWrapper>
  );
}
